import React from "react";
import { RouteData, withSiteData } from "react-static";
//
import Address from "components/address";
//
export default withSiteData(({ address }) => (
  <RouteData>{({ site }) => <Address {...address[site]} />}</RouteData>
));
